import { HMSAudioNode } from './HMSAudioNode';

export class HMSScreenBroadcastAudioReceiverNode extends HMSAudioNode {
  constructor() {
    super('screen_broadcast_audio_receiver_node');
  }
}
